import { render, staticRenderFns } from "./ProductCollection.vue?vue&type=template&id=796d4408"
import script from "./ProductCollection.vue?vue&type=script&lang=js"
export * from "./ProductCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports